class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    if(typeof(debounce) === 'function'){
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
    }

    const facetForm = this.querySelector('form');
    try {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    } catch (error) {

    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper && typeof (onKeyUpEscape) === 'function') {
      facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    //const countContainer = document.getElementById('ProductCount');
    //const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
//     if (countContainer){
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop){
//       countContainerDesktop.classList.add('loading');
//     }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    //const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    //const container = document.getElementById('ProductCount');
    //const containerDesktop = document.getElementById('ProductCountDesktop');
    //container.innerHTML = count;
    //container.classList.remove('loading');
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements =
    parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    console.log('binding events');

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      console.log('here ');
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRangeBar extends HTMLElement {
  constructor() {
    super();

    var _this1 = this;
  }

  connectedCallback() {

    var _this = this;

    this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
    this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
    this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
    this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience

    this.textInputLowerBound.addEventListener('focus', function () {
      return _this.textInputLowerBound.select();
    });
    this.textInputHigherBound.addEventListener('focus', function () {
      return _this.textInputHigherBound.select();
    }); // Keep in sync the range with the text input fields

    this.textInputLowerBound.addEventListener('change', function (event) {
      console.log('event.target.value ', event.target.value);
      // event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      _this.textInputLowerBound.value = event.target.value;
      _this.rangeLowerBound.value = event.target.value;
      _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
      updatePriceFilters();
    });
    this.textInputHigherBound.addEventListener('change', function (event) {
      // event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      _this.rangeHigherBound.value = event.target.value;
      _this.textInputHigherBound.value = event.target.value;
      _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
      updatePriceFilters();
    });
    this.rangeLowerBound.addEventListener('change', function (event) {
      _this.textInputLowerBound.value = event.target.value;

      _this.textInputLowerBound.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    this.rangeHigherBound.addEventListener('change', function (event) {
      _this.textInputHigherBound.value = event.target.value;

      _this.textInputHigherBound.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }); // We also have to bound the two range sliders

    this.rangeLowerBound.addEventListener('input', function (event) {
      console.log('interacting');
      event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

      event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
      _this.textInputLowerBound.value = event.target.value;
    });
    this.rangeHigherBound.addEventListener('input', function (event) {
      console.log('interacting');
      event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

      event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
      _this.textInputHigherBound.value = event.target.value;
    });
    this.rangeLowerBound.addEventListener('mouseup', function (event) {
      console.log('interacting done');
      let lowerNum = document.querySelectorAll('.input-prefix__field')[0].value ? document.querySelectorAll('.input-prefix__field')[0].value : document.querySelectorAll('.input-prefix__field')[0].placeholder;
      let higherNum = document.querySelectorAll('.input-prefix__field')[1].value ? document.querySelectorAll('.input-prefix__field')[1].value : document.querySelectorAll('.input-prefix__field')[1].placeholder;
      let purgedUrl = removeURLParameter(window.location.href, 'price');
      let newLink = `${purgedUrl}?price=${lowerNum}~${higherNum}`;


      console.log(`in mouseup lowerNum:${lowerNum} higherNum:${higherNum} newLink:${newLink}`);

      document.querySelector('.inDiv--price-link-2').href = newLink;
      document.querySelector('.inDiv--price-link').href = newLink;

      document.querySelector('.inDiv--price-link-2').click();
      document.querySelector('.inDiv--price-link').click();
    });
    this.rangeHigherBound.addEventListener('mouseup', function (event) {
      console.log('interacting done');
      let lowerNum = document.querySelectorAll('.input-prefix__field')[0].value ? document.querySelectorAll('.input-prefix__field')[0].value : document.querySelectorAll('.input-prefix__field')[0].placeholder;
      let higherNum = document.querySelectorAll('.input-prefix__field')[1].value ? document.querySelectorAll('.input-prefix__field')[1].value : document.querySelectorAll('.input-prefix__field')[1].placeholder;
      let purgedUrl = removeURLParameter(window.location.href, 'price');
      let newLink = `${purgedUrl}?price=${lowerNum}~${higherNum}`;

      console.log(`in mouseup lowerNum:${lowerNum} higherNum:${higherNum} newLink:${newLink}`);

      document.querySelector('.inDiv--price-link-2').href = newLink;
      document.querySelector('.inDiv--price-link').href = newLink;

      document.querySelector('.inDiv--price-link-2').click();
      document.querySelector('.inDiv--price-link').click();

    });


  }
}

customElements.define('price-ranger', PriceRangeBar);

function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
              pars.splice(i, 1);
          }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

function updatePriceFilters() {
  let lowerNum = '';
  let higherNum = '';

  if (window.innerWidth > 990) {
    console.log('in bigger than ', window.innerWidth);
    lowerNum = document.querySelectorAll('.input-prefix__field')[0].value ? document.querySelectorAll('.input-prefix__field')[0].value : document.querySelectorAll('.input-prefix__field')[0].placeholder;
    higherNum = document.querySelectorAll('.input-prefix__field')[1].value ? document.querySelectorAll('.input-prefix__field')[1].value : document.querySelectorAll('.input-prefix__field')[1].placeholder;
  } else {
    console.log('in bigger than ', window.innerWidth);
    lowerNum = document.querySelectorAll('.input-prefix__field')[2].value ? document.querySelectorAll('.input-prefix__field')[2].value : document.querySelectorAll('.input-prefix__field')[2].placeholder;
    higherNum = document.querySelectorAll('.input-prefix__field')[3].value ? document.querySelectorAll('.input-prefix__field')[3].value : document.querySelectorAll('.input-prefix__field')[3].placeholder;
  }

  let purgedUrl = removeURLParameter(window.location.href, 'price');
  let hasQueryParamsCheck = hasQueryParams(purgedUrl);
  let newLink = hasQueryParamsCheck ? `${purgedUrl}&price=${lowerNum}~${higherNum}` : `${purgedUrl}?price=${lowerNum}~${higherNum}`;


  console.log(`in updatePriceFilters lowerNum:${lowerNum} higherNum:${higherNum} newLink:${newLink}`);

  document.querySelector('.inDiv--price-link-2').href = newLink;
  document.querySelector('.inDiv--price-link').href = newLink;

  document.querySelector('.inDiv--price-link-2').click();
  document.querySelector('.inDiv--price-link').click();
}

function hasQueryParams(url) {
  return url.includes('?');
}
